import exampleSurvey from '../../public/examples/fixed-room-dxf/survey.json';
import { DEFAULT_FORM_DATA } from './survey.js';

export const GUIDE_PATHS = {
    rooms: '/house-planner-fixed-room-dimensions',
    cad: '/ai-floor-plan-dxf-export',
};
export const EXAMPLE_ROOT = '/examples/fixed-room-dxf';
export const EXAMPLE_STUDIO_URL = '/?example=fixed-bedroom#generator';

// A named, owner-created synthetic example. URLs cannot inject arbitrary survey
// values, account state, saved-project identifiers or HTML into the studio.
export function readExampleBrief(search) {
    if (new URLSearchParams(search).get('example') !== 'fixed-bedroom') return null;
    return {
        patch: structuredClone({ ...DEFAULT_FORM_DATA, ...exampleSurvey }),
        read: ['Example brief: 2,400 sq ft target, 2 stories, 3 bedrooms, 3 bathrooms, 1-car garage.',
            'Bedroom 2 fixed at a nominal 14 × 12 ft. Review and change any answer before generating.'],
    };
}
